import { PROGRAMS } from "@/data";
import { ArrowUpRight } from "lucide-react";

export const Programs = () => {
  return (
    <section id="programs" className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#4A4A4A]">What We Offer</span>
        <h2 className="mt-3 font-heading font-black tracking-tight text-3xl md:text-4xl text-[#0F0F0F] leading-tight">
          Programs & services that build lasting independence
        </h2>
        <p className="mt-4 text-base md:text-lg text-[#4A4A4A] leading-relaxed">
          Every resident receives a tailored blend of support designed to meet them where they are and move them toward where they want to be.
        </p>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {PROGRAMS.map((p) => (
          <div
            key={p.title}
            data-testid={`program-${p.title.toLowerCase().replace(/\s/g, "-")}`}
            className="group bg-white border-2 border-[#0F0F0F]/10 p-7 hover:border-[#0F0F0F] hover:-translate-y-1 hover:shadow-[6px_6px_0px_#FFC000] transition-all"
          >
            <div className="flex items-start justify-between">
              <span className="w-12 h-12 bg-[#FFC000] border-2 border-[#0F0F0F] flex items-center justify-center">
                <p.icon size={22} strokeWidth={2} className="text-[#0F0F0F]" />
              </span>
              <ArrowUpRight size={20} className="text-[#0F0F0F]/30 group-hover:text-[#0F0F0F] transition-colors" />
            </div>
            <h3 className="mt-5 font-heading font-bold text-lg text-[#0F0F0F]">{p.title}</h3>
            <p className="mt-2 text-sm text-[#4A4A4A] leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
